import { HorizontalAlignment, ItalicStyle, TextWrap, UnderlineStyle, VerticalAlignment } from "../../models/shared/formats/Text";
// HorizontalAlignment
export const horizontalAlignmentByEncodedValue = {
  0: HorizontalAlignment.DEFAULT,
  256: HorizontalAlignment.RIGHT,
  512: HorizontalAlignment.LEFT,
  768: HorizontalAlignment.CENTER
};
export const encodedValueByHorizontalAlignment = {
  [HorizontalAlignment.RIGHT]: 256,
  [HorizontalAlignment.LEFT]: 512,
  [HorizontalAlignment.CENTER]: 768,
  [HorizontalAlignment.DEFAULT]: 0
};

// VerticalAlignment
export const verticalAlignmentByEncodedValue = {
  0: VerticalAlignment.DEFAULT,
  1024: VerticalAlignment.TOP,
  2048: VerticalAlignment.BOTTOM,
  3072: VerticalAlignment.MIDDLE
};
export const encodedValueByVerticalAlignment = {
  [VerticalAlignment.TOP]: 1024,
  [VerticalAlignment.BOTTOM]: 2048,
  [VerticalAlignment.MIDDLE]: 3072,
  [VerticalAlignment.DEFAULT]: 0
};

// UnderlineStyle
export const underlineStyleByEncodedValue = {
  0: UnderlineStyle.NONE,
  16: UnderlineStyle.UNDERLINE,
  32: UnderlineStyle.STRIKETHROUGH
};
export const encodedValueByUnderlineStyle = {
  [UnderlineStyle.UNDERLINE]: 16,
  [UnderlineStyle.STRIKETHROUGH]: 32,
  [UnderlineStyle.NONE]: 0
};

// ItalicStyle
export const italicStyleByEncodedValue = {
  0: ItalicStyle.NONE,
  4: ItalicStyle.ITALIC
};
export const encodedValueByItalicStyle = {
  [ItalicStyle.ITALIC]: 4,
  [ItalicStyle.NONE]: 0
};

// TextWrap
export const textWrapByEncodedValue = {
  0: TextWrap.NONE,
  64: TextWrap.ON
};
export const encodedValueByTextWrap = {
  [TextWrap.ON]: 64,
  [TextWrap.NONE]: 0
};

// Encode / Decode functions
export const decodeTextFormat = _ref => {
  let {
    horizontalAlignment,
    italicStyle,
    textWrap,
    underlineStyle,
    verticalAlignment
  } = _ref;
  return {
    horizontalAlignment: horizontalAlignmentByEncodedValue[horizontalAlignment] || HorizontalAlignment.DEFAULT,
    italicStyle: italicStyleByEncodedValue[italicStyle] || ItalicStyle.NONE,
    textWrap: textWrapByEncodedValue[textWrap] || TextWrap.NONE,
    underlineStyle: underlineStyleByEncodedValue[underlineStyle] || UnderlineStyle.NONE,
    verticalAlignment: verticalAlignmentByEncodedValue[verticalAlignment] || VerticalAlignment.DEFAULT
  };
};
export const encodeTextFormat = decodedFormat => {
  const encodedValuesByTextFormat = {
    horizontalAlignment: encodedValueByHorizontalAlignment[decodedFormat.horizontalAlignment],
    italicStyle: encodedValueByItalicStyle[decodedFormat.italicStyle],
    textWrap: encodedValueByTextWrap[decodedFormat.textWrap],
    underlineStyle: encodedValueByUnderlineStyle[decodedFormat.underlineStyle],
    verticalAlignment: encodedValueByVerticalAlignment[decodedFormat.verticalAlignment]
  };
  return encodedValuesByTextFormat;
};
//# sourceMappingURL=Text.js.map